import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const BrandBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.12, 1]);
  return (
    <section ref={ref} className="mx-auto max-w-[1400px] px-5 pt-20 lg:px-10 lg:pt-28" data-testid="brand-banner">
      <div className="slab-frame relative aspect-[4/3] overflow-hidden rounded-[20px] sm:aspect-[2000/744] sm:rounded-[32px]">
        <motion.img style={{ scale }} src="/brand/banner.webp" alt="InstantTCGZ — trading cards, singles and graded slabs" className="h-full w-full object-cover" />
      </div>
    </section>
  );
};
